<div class="assignee-filter">
  <h6>Assignee:</h6>
  <ng-select
    [items]="assignees"
    [multiple]="true"
    bindLabel="name"
    [closeOnSelect]="false"
    bindValue="id"
    placeholder="Filter by Assignee"
    [clearable]="true"
    [(ngModel)]="filteredAssignees"
    (ngModelChange)="onAssigneeChange($event)"
    notFoundText="No assignee found"
    (open)="scrollDropdownToTop()">
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="items-container" *ngIf="filteredAssigneesCount === 1">
        <div class="ng-value" *ngFor="let item of items">
          <span class="ng-value-label">
            {{ item.id !== -1 ? (item.name?.length > 30 ? item.name.substr(0, 20) + '...' : item.name) : '' }}
          </span>
        </div>
      </div>
      <div class="ng-value" *ngIf="filteredAssigneesCount > 1">
        <span class="ng-value-label">{{ filteredAssigneesCount }} assignee(s) selected</span>
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <div class="assignee-option">
        <input type="checkbox" [ngModel]="item$.selected" />

        <div class="avatar" *ngIf="!isDefault(item.id)">{{ getInitials(item.name) }}</div>

        <div *ngIf="isDefault(item.id) && item.id != -1">
          <img height="20" width="20" src="assets/img/non-assign.svg" alt="" />
        </div>

        <div class="details">
          <strong *ngIf="isDefault(item.id)" [ngClass]="item.id == -1 ? 'anyAssignee' : 'unAssignee'">{{
            item.name
          }}</strong>
          <span *ngIf="!isDefault(item.id)" class="name">{{ item.name }}</span>
          <span *ngIf="item.email" class="email" [title]="item.email">{{ item.email }}</span>
        </div>
      </div>
    </ng-template>
  </ng-select>
</div>
